import { LoadableLazy } from '@confluence/loadable';

export const StarredEmptyStateLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StarredEmptyState" */ '../components/StarredEmptyState.tsx'
			)
		).StarredEmptyState,
});
